module.exports = __webpack_public_path__ + "static/media/popup_closed.51fd6bcc.svg";